import React from 'react';

import CuotaCompra  from 'components/Tvendo/Sale/QuotaBPartner/Colgate/Periodo/CuotaCompra/List.js';

export default function () {
  return <CuotaCompra  />;
}